var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.89d40d436050f7beeafc63db92796703.svg#g';
                    var viewUrl = 'sprites.89d40d436050f7beeafc63db92796703.svg#view-g';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };